/**
 * Hero Promotion - Copy promo code to clipboard.
 * Uses event delegation so a single listener handles all promo cards on the page.
 */
(function () {
  if (window.__heroPromotionCopyInit) return;
  window.__heroPromotionCopyInit = true;

  async function copyText(text) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (e) {
      // fall through to legacy fallback
    }

    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, ta.value.length);
      document.execCommand('copy');
      document.body.removeChild(ta);
      return true;
    } catch (e) {
      return false;
    }
  }

  function setFeedback(card, ok) {
    const feedback = card.querySelector('.copy-feedback');
    card.classList.toggle('copied', ok);
    if (feedback) {
      feedback.textContent = ok ? 'Copied!' : 'Could not copy. Please copy manually.';
    }
    setTimeout(() => {
      card.classList.remove('copied');
      if (feedback) feedback.textContent = '';
    }, 2500);
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.copy-code-btn');
    if (!btn) return;

    const card = btn.closest('.promo-card');
    if (!card) return;

    const codeEl = card.querySelector('.promo-code');
    const code = (codeEl?.dataset?.code || codeEl?.textContent || '').trim();
    if (!code) return;

    const ok = await copyText(code);
    setFeedback(card, ok);
  });
})();
